// Copyright (c) 2025 Signal from Noise, Inc. All rights reserved.
//
// This software is the confidential and proprietary information of
// Signal from Noise, Inc. You shall not disclose such Confidential Information
// and shall use it only in accordance with the terms of a separate license
// agreement entered into with Signal from Noise, Inc.
//
// Authors: /AUTHORS

// DO NOT EDIT.
// Code generated in 2025 by '/services/controlplane/generate/websocket_client/websocket_client.go'
// This file is intended for version control.


export const AssetLifecycleStates = {
  AwaitingUpload: "awaiting_upload",
  Uploaded: "uploaded",
  QueuedForProcessing: "queued_for_processing",
  Reset: "reset",
  Archived: "archived",
  DeleteRequested: "delete_requested",
  Deleted: "deleted",
  Processing: "processing",
  Ready: "ready",
  Failed: "failed",
  Extracting: "extracting",
  Extracted: "extracted",
  ExtractionFailed: "extraction_failed",
  Transcribing: "transcribing",
  Transcribed: "transcribed",
  TranscriptionFailed: "transcription_failed",
  EmbeddingsGenerating: "embeddings_generating",
  EmbeddingsGenerated: "embeddings_generated",
  EmbeddingFailed: "embeddings_failed",
  Summarizing: "summarizing",
  Summarized: "summarized",
  SummarizationFailed: "summarization_failed",
  KeywordsGenerating: "keywords_generating",
  KeywordsGenerated: "keywords_generated",
  KeywordsFailed: "keywords_failed",
  TooManyRequests: "too_many_requests",
};

// AssetLifecycleState provides controlled references to LifecycleState values.
export type AssetLifecycleState = typeof AssetLifecycleStates[keyof typeof AssetLifecycleStates];
